module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Ramy-Youssef.a21ba4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Ramy-Youssef.jpg
// module id = SSuv
// module chunks = 0